import React from 'react';
import { motion } from 'framer-motion';
const modules = [{
  icon: '🦴',
  title: 'Módulo 1 — Columna Vertebral',
  desc: 'Hernia de disco cervical, dorsal y lumbar. Escoliosis. Osteoporosis. Espondilolistesis. Post-cirugía de columna. Qué hacer, qué evitar y qué decir en cada caso.'
}, {
  icon: '🦵',
  title: 'Módulo 2 — Miembros Inferiores',
  desc: 'Artrosis de rodilla. Prótesis de cadera y rodilla. Lesión de LCA. Fascitis plantar. Adaptaciones ejercicio por ejercicio.'
}, {
  icon: '💪',
  title: 'Módulo 3 — Miembros Superiores',
  desc: 'Hombro congelado por fases. Síndrome del manguito rotador. Túnel carpiano. Artrosis de manos. Cómo modificar cada ejercicio sin romper la clase.'
}, {
  icon: '❤️',
  title: 'Módulo 4 — Condiciones Sistémicas',
  desc: 'Hipertensión arterial. Diabetes tipo 2. Fibromialgia. Lo que podés hacer, lo que no podés hacer y las señales de alerta que requieren parar.'
}, {
  icon: '🌸',
  title: 'Módulo 5 — Salud de la Mujer',
  desc: 'Embarazo trimestre por trimestre. Post-parto y diastasis abdominal. Incontinencia urinaria. Prolapso. Protocolo completo para cada etapa.'
}, {
  icon: '🚨',
  title: 'Módulo 6 — Herramientas de Seguridad',
  desc: 'Checklist de banderas rojas. Tabla maestra de equivalencias. Protocolo de emergencia listo para imprimir. Consentimiento informado editable para condiciones especiales.'
}];
export const SafePilatesModules = () => {
  return <section className="py-8 md:py-14 bg-sage-50" data-id="element-320">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-321">
        <div className="mb-6 md:mb-12 text-center" data-id="element-322">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-white rounded-full text-sage-700 font-bold text-xs md:text-sm shadow-sm mb-4 md:mb-6" data-id="element-323">
            <span className="text-green-500" data-id="element-324">✅</span> SAFE PILATES PRO™
            INCLUYE:
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8" data-id="element-325">
          {modules.map((mod, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-xl md:rounded-2xl p-5 md:p-8 shadow-sm border border-sage-100" data-id="element-326">
              <div className="text-2xl md:text-4xl mb-2 md:mb-4" data-id="element-327">
                {mod.icon}
              </div>
              <h3 className="text-base md:text-xl font-bold text-charcoal mb-2 md:mb-3 font-playfair" data-id="element-328">
                {mod.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-xs md:text-sm" data-id="element-329">
                {mod.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};